import { Alert, Button, Form } from 'antd';
import { CodeInput } from '../../../../../shared/components/CodeInput';

interface TotpEnrollmentWizardProps {
  secret: string;
  qrCodeDataUrl: string;
  error: string | null;
  submitting: boolean;
  onVerify: (code: string) => void;
  onCancel: () => void;
}

/** Scan the QR (or enter the secret manually), then prove the first code before anything is enabled. */
export function TotpEnrollmentWizard({ secret, qrCodeDataUrl, error, submitting, onVerify, onCancel }: TotpEnrollmentWizardProps) {
  return (
    <div className="rounded-lg border border-line bg-surface p-6">
      <h2 className="text-base font-semibold text-fg">Scan this QR code</h2>
      <p className="mt-1.5 text-sm text-muted">Use an authenticator app such as Google Authenticator or 1Password.</p>
      <img src={qrCodeDataUrl} alt="Two-factor authentication QR code" className="my-6 size-48 rounded-md border border-line" />
      <p className="mb-1 text-xs text-muted">Can't scan it? Enter this key manually:</p>
      <code className="block rounded-md bg-page px-3 py-2 font-mono text-sm break-all text-fg">{secret}</code>

      {error && <Alert className="mt-5" type="error" title={error} showIcon />}
      <Form<{ code: string }> className="mt-5" layout="vertical" requiredMark={false} onFinish={(values) => onVerify(values.code)} disabled={submitting}>
        <Form.Item name="code" label="Enter the 6-digit code" rules={[{ required: true, message: 'Enter the 6-digit code' }]}>
          <CodeInput autoFocus onComplete={onVerify} />
        </Form.Item>
        <div className="flex gap-2">
          <Button type="primary" htmlType="submit" loading={submitting}>
            Verify and enable
          </Button>
          <Button onClick={onCancel} disabled={submitting}>
            Cancel
          </Button>
        </div>
      </Form>
    </div>
  );
}
